var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThickpaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 100,
    viewBox: "0 0 108 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1002 27.0297C45.243 26.3505 43.9976 26.4947 43.3183 27.3518C42.6391 28.2088 42.7832 29.4544 43.6404 30.1336L52.5512 37.1955C53.2717 37.7665 54.2906 37.7665 55.011 37.1955L63.9219 30.1336C64.7791 29.4544 64.9232 28.2088 64.244 27.3518C63.5647 26.4947 62.3193 26.3505 61.4621 27.0297L55.7613 31.5476V1.9802C55.7613 0.886535 54.8748 0 53.7811 0C52.6875 0 51.8009 0.886535 51.8009 1.9802V31.5476L46.1002 27.0297ZM4.27619 39.604C2.08896 39.604 0.315796 41.3771 0.315796 43.5644V54.4554C0.315796 56.6427 2.08896 58.4158 4.27619 58.4158H103.286C105.473 58.4158 107.246 56.6427 107.246 54.4554V43.5644C107.246 41.3771 105.473 39.604 103.286 39.604H4.27619ZM46.1002 72.9703C45.243 73.6495 43.9976 73.5054 43.3183 72.6482C42.6391 71.7912 42.7832 70.5456 43.6404 69.8664L52.5512 62.8045C53.2717 62.2335 54.2906 62.2335 55.011 62.8045L63.9219 69.8664C64.7791 70.5456 64.9232 71.7912 64.244 72.6482C63.5647 73.5054 62.3193 73.6495 61.4621 72.9703L55.7613 68.4524V98.0198C55.7613 99.1139 54.8748 100 53.7811 100C52.6875 100 51.8009 99.1139 51.8009 98.0198V68.4524L46.1002 72.9703Z",
    fill: "#F1B545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickpaper);
export default __webpack_public_path__ + "static/media/thickpaper.b0ca76d1655d1a08bfa9fbfce4089196.svg";
export { ForwardRef as ReactComponent };